import { FileSearch } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { Forslag } from '../../api/filer';

interface Props {
  forslag: Forslag;
  lagrer: boolean;
  onBekreft: (forslag: Forslag) => void;
  onAvvis: (forslag: Forslag) => void;
  /** Vis spørsmålet også, når kortet står i en liste og ikke ved spørsmålet. */
  visSporsmal?: boolean;
}

/**
 * Et forslag til svar fra et dokument (T102): hva dokumentet viser, og svaret det peker på. Kunden bruker forslaget,
 * eller sier at det ikke stemmer. Ingenting er lagret før kunden velger.
 */
export default function ForslagKort({ forslag, lagrer, onBekreft, onAvvis, visSporsmal = false }: Props) {
  const { t } = useTranslation();

  return (
    <section aria-label={t('reise.forslag.tittel')} className="rounded-xl border border-aksent-200 bg-aksent-50/70 p-5">
      <p className="etikett mb-2 flex items-center gap-2 text-aksent-800">
        <FileSearch aria-hidden="true" className="h-4 w-4" />
        {t('reise.forslag.fra', { fil: forslag.filnavn })}
      </p>
      {visSporsmal && <p className="mb-1 font-medium text-slate-900">{forslag.sporsmalTekst}</p>}
      <p className="text-slate-700">{forslag.funn}</p>
      <p className="mt-3 text-slate-900">
        {t('reise.forslag.forslag')} <span className="font-semibold">{forslag.forslagTekst}</span>
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button type="button" disabled={lagrer} onClick={() => onBekreft(forslag)} className="knapp-primaer min-h-[2.5rem] px-4 text-sm">
          {t('reise.forslag.bruk')}
        </button>
        <button type="button" disabled={lagrer} onClick={() => onAvvis(forslag)} className="knapp-stille min-h-[2.5rem] text-sm">
          {t('reise.forslag.stemmerIkke')}
        </button>
      </div>
    </section>
  );
}
